import { render, staticRenderFns } from "./VisitorCard.vue?vue&type=template&id=8b4661f6&"
import script from "./VisitorCard.vue?vue&type=script&lang=js&"
export * from "./VisitorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports